// extracted by mini-css-extract-plugin
export default {"inputGroup":"InputWithEdit_inputGroup__CYLNI","input":"InputWithEdit_input__FDims","disable":"InputWithEdit_disable__CWS-k"};